module.exports = __webpack_public_path__ + "img/2022_ram-2500.da6614ae.png";